const SUBJECT_LABELS = {
  ru: {
    math: 'Математика',
    physics: 'Физика',
    cs: 'Информатика',
    english: 'Английский язык',
  },
  en: {
    math: 'Math',
    physics: 'Physics',
    cs: 'Computer Science',
    english: 'English',
  },
};

export function getSubjectLabel(subject, lang = 'en') {
  return SUBJECT_LABELS[lang]?.[subject] || subject || '';
}

export function isSelectedTimeslotPast(linkStatus, now = new Date()) {
  const slotStart = linkStatus?.selected_timeslot_start;
  if (!slotStart) {
    return false;
  }
  return new Date(slotStart).getTime() <= now.getTime();
}

export function isSelectedTimeslotOlderThanMinutes(linkStatus, minutes, now = new Date()) {
  const selectedAt = linkStatus?.selected_timeslot_selected_at;
  if (!selectedAt) {
    return false;
  }
  return now.getTime() - new Date(selectedAt).getTime() > minutes * 60 * 1000;
}

export function shouldConfirmSelectedTimeslotReplacement(linkStatus, now = new Date()) {
  return Boolean(linkStatus?.slot_id) && !isSelectedTimeslotPast(linkStatus, now) && isSelectedTimeslotOlderThanMinutes(linkStatus, 10, now);
}

export function buildReplacementWarningMessage(linkStatus, lang, formattedTime) {
  const subject = getSubjectLabel(linkStatus?.selected_timeslot_program, lang);
  if (lang === 'ru') {
    return `У вас уже выбран слот: ${subject}, ${formattedTime}. Выбор другого слота отменит старый. Возможность вернуть старый слот не гарантируется.`;
  }
  return `You already selected a slot: ${subject}, ${formattedTime}. Choosing another slot will cancel the old one. Getting the old slot back is not guaranteed.`;
}

export function getPastSlotLockMessage(lang) {
  if (lang === 'ru') {
    return 'Время вашего слота уже прошло. Обратитесь в info@leaders.tech или тг-бот techleadersbot.';
  }
  return 'Your timeslot has already passed. Please contact info@leaders.tech or the techleadersbot Telegram bot.';
}

export function getSubjectEmptyStateMessage(lang) {
  if (lang === 'ru') {
    return 'Сейчас свободных слотов по выбранному предмету нет. Зайдите позже.';
  }
  return 'There are no free slots for the selected subject right now. Please check back later.';
}
